<template>
  <Loader v-if="loading" />
  <div v-else class="content">
    <div class="flex">
      <h1>Warehouse Products</h1>
    </div>
    <Table class="margin-top" :perpage="100" :filters="filters" :columns="columns" :rows="rows" />
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  data: () => ({
    loading: false,
    saving: false,
    records: [],
    columns: {
      variant_id: { title: 'Variant ID' },
      product_id: { title: 'Product ID' },
      sku: {},
      ean: {},
      warehouse_stock: {},
      warehouse_stock_updated_at: {}
    },
    filters: {}
  }),
  computed: {
    rows () {
      return this.records.map(row => {
        row.menu = [
          {
            name: 'Update status',
            onClick: row => this.refreshStock(row)
          }
        ]
        return row
      })
    }
  },
  methods: {
    load () {
      Vue.$api.get('/warehouse/products', {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: data => this.records = data
      })
    },
    refreshStock (row) {
      Vue.$api.post('/warehouse/products/' + row.id + '/refresh-stock', {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: data => this.updateRecord(data)
      })
    },
    updateRecord (record) {
      const updated = this.records.filter(row => row.id === record.id)
      if (updated.length > 0) {
        updated[0].warehouse_stock = record.warehouse_stock
        updated[0].warehouse_stock_updated_at = record.warehouse_stock_updated_at
      }
    }
  },
  created () {
    this.load()
  }
}
</script>

<style scoped>

</style>
